import { ToastContainer } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { PayerNameContextFromSingleOrderLayoutProvider } from "./medonc/context/payerNameContextFromSingleOrderLayout";
import { RemoteConfigProvider } from "./medonc/context/remoteConfigContext";
import { TablesContextProvider } from "./medonc/context/tablesContextProvider";
import { UserThemeContextProvider } from "./medonc/context/userThemeContext";
import "./index.css";
import store from "./medonc/redux/store/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RemoteConfigProvider>
        <UserThemeContextProvider>
          <TablesContextProvider>
            <PayerNameContextFromSingleOrderLayoutProvider>
              <ToastContainer />
              <App />
            </PayerNameContextFromSingleOrderLayoutProvider>
          </TablesContextProvider>
        </UserThemeContextProvider>
      </RemoteConfigProvider>
    </Provider>
  </React.StrictMode>,
);
